import React, { Component } from 'react';
import {
  ProgressStep,
  ProgressIndicator,
  Loading,
  Modal,
} from 'carbon-components-react';
import { NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getDmService, insertDmService } from '../../../services/Api';
import { Card } from '../../../components';
import validarCPF from '../../../lib/validations';

class Register extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // isLoading: false,
      email: '',
      cpf: '',
      password: '',
      confirmPassword: '',
      fotoBase64: '',
      nome: '',
      sobrenome: '',
      // supervisor: 1,
      // nivel: 10,
      status: { id: 3 },
      supervisores: [],
      // error: null,
      btnName: 'Próximo',
      currentStep: 1,
      showBack: false,
      nomeArquivo: null,
      // file: null,
      backgroundImage: '',
      nextIsDisabled: false,
      targetForm: 'form',
      successModel: false,
      selectedSupervisor: null,
    };
  }

  componentWillMount() {
    this.getSupervisores();
  }

  getSupervisores() {
    getDmService('Usuario/GetSupervisores')
      .then(data => {
        const items = [];
        data.forEach(item => {
          items.push({ id: item.id, label: item.nome });
        });
        this.setState({ supervisores: items });
      })
      .catch(err => {
        console.log(err);
      });
  }

  onChangeText = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onChangePassword = event => {
    const { password } = this.state;
    this.setState({ [event.target.name]: event.target.value });
    if (event.target.value !== password)
      event.target.setCustomValidity('Senha e Confirmar senha precisam ser iguais.');
    else event.target.setCustomValidity('');
  };

  save = () => {
    const {
      email,
      password,
      confirmPassword,
      nome,
      sobrenome,
      cpf,
      fotoBase64,
      selectedSupervisor,
      status,
    } = this.state;

    const objSupervisor = selectedSupervisor && selectedSupervisor.id !== null ? { id: selectedSupervisor.id } : { id: 0 };
    const formData = {
      email,
      password,
      confirmPassword,
      nome,
      sobrenome,
      cpf,
      fotoBase64,
      supervisor: objSupervisor,
      status,
    };

    this.setState({ isSaving: true });
    insertDmService('/Usuario', formData)
      .then(() => {
        this.setState({ isSaving: false });
        this.toggleSuccessModal();
      })
      .catch(err => {
        if (typeof err.error.response.data.modelState !== 'undefined') {
          let error = 'Ocorreu o seguinte erro: ';

          const erros = err.error.response.data.modelState;
          for (const p in erros) {
            let name = p.replace('model.', '');
            name = name[0].toUpperCase() + name.slice(1);
            error += `${name}: ${erros[p]}; `;
          }
          toast.error(error);
        } else {
          toast.error('Ocorreu um erro ao salvar os dados, tente novamente mais tarde');
        }
        this.setState({ isSaving: false });
      });
  };

  toggleSuccessModal = () => {
    this.setState(prevState => ({
      successModel: !prevState.successModel,
    }));
  };

  handleUploadFile = files => {
    if (files.length) {
      const file = files[0];
      this.setState({ nomeArquivo: file.name });
      const reader = new FileReader();
      const self = this;
      reader.onloadend = () => {
        self.setState({
          backgroundImage: reader.result,
          fotoBase64: reader.result.replace(/data:image\/(png|jpeg);base64,/g, ''),
        });
      };
      reader.readAsDataURL(file);
    }
  };

  removeFile = () => {
    this.setState({ backgroundImage: null, fotoBase64: null, nomeArquivo: null });
  };

  onChange = item => {
    this.setState({ selectedSupervisor: item.selectedItem });
  };

  onsubmit = e => {
    const { currentStep } = this.state;
    e.preventDefault();
    console.log(currentStep);
    if (currentStep === 1 || e.target.checkValidity()) {
      if (currentStep === 3) {
        this.save();
      } else {
        this.setState({ currentStep: currentStep + 1 }, () => {
          this.checkState();
        });
      }
    }
  };

  handleSubmit = step => {
    const { currentStep } = this.state;
    if ((currentStep === 1 && step > 0) || step < 0) {
      this.setState({ currentStep: currentStep + step }, () => {
        this.checkState();
      });
    }
  };

  checkState = () => {
    const { currentStep } = this.state;
    if (currentStep === 2) {
      this.setState({
        targetForm: 'form1',
        showBack: true,
        btnName: 'Próximo',
      });
    }
    if (currentStep === 3) {
      this.setState({
        targetForm: 'form2',
        btnName: 'Salvar',
      });
    }
    if (currentStep === 1) {
      this.setState({
        targetForm: 'form',
        showBack: false,
      });
    }
  };

  onChangeCPF = event => {
    this.setState({ [event.target.name]: this.formatarCpf(event.target.value) });
    if (validarCPF(event.target.value)) event.target.setCustomValidity('');
    else event.target.setCustomValidity('O CPF informado é inválido.');
  };

  formatarCpf = inputCpf => {
    let cpf = inputCpf;
    if (cpf && cpf.length > 14) return cpf.slice(0, 14);
    cpf = cpf.replace(/\D/g, '');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d)/, '$1.$2');
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    return cpf;
  };

  closeModal = () => {
    const { history } = this.props;
    this.toggleSuccessModal();
    history.push('/login');
  };

  render() {
    const {
      email,
      password,
      confirmPassword,
      nome,
      sobrenome,
      // supervisores,
      cpf,
      // selectedSupervisor,
      btnName,
      currentStep,
      showBack,
      nomeArquivo,
      backgroundImage,
      isSaving,
      nextIsDisabled,
      targetForm,
      successModel,
    } = this.state;

    return (
      <div className="login-block">
        <Card>
          <h2 className="logo">DMJob</h2>
          <ProgressIndicator>
            <ProgressStep current={currentStep === 1} complete={currentStep > 1} />
            <ProgressStep current={currentStep === 2} complete={currentStep > 2} />
            <ProgressStep current={currentStep === 3} />
          </ProgressIndicator>
          {currentStep === 1 ? (
            <form id="form" onSubmit={this.onsubmit}>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin foto-perfil">
                <div
                  style={{ backgroundImage: `url('${backgroundImage}')` }}
                  className="img-cadastro"
                />
                <label className="bx--label">Minha foto</label>
                <p>Arquivos jpg ou png de no máximo 500kb.</p>
              </div>
              <div className="bx--col-md-12">
                <label className="bx--btn btn-secondary-color v-md-margin btn-white">
                  Adicionar arquivo
                  <div className="hide">
                    <input type="file" onChange={e => this.handleUploadFile(e.target.files)} />
                  </div>
                </label>
              </div>
              {nomeArquivo && (
                <div className="bx--col-md-6">
                  <div className="file-upload">
                    <span>{nomeArquivo}</span>
                    <svg
                      onClick={() => this.removeFile()}
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zM4 7v2h8V7H4z" />
                    </svg>
                  </div>
                </div>
              )}
            </form>
          ) : currentStep === 2 ? (
            <form id="form1" onSubmit={this.onsubmit}>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Nome</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="Nome"
                  name="nome"
                  value={nome}
                  onChange={this.onChangeText}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Sobrenome</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="Sobrenome"
                  name="sobrenome"
                  value={sobrenome}
                  onChange={this.onChangeText}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">CPF</label>
                <input
                  type="text"
                  className="bx--text-input"
                  required
                  placeholder="CPF"
                  name="cpf"
                  value={cpf}
                  onChange={this.onChangeCPF}
                  pattern="\d{3}\.\d{3}\.\d{3}-\d{2}"
                  title="Digite um CPF válido"
                />
              </div>
             
            </form>
          ) : (
            <form id="form2" onSubmit={this.onsubmit}>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">E-mail</label>
                <input
                  type="email"
                  className="bx--text-input"
                  required
                  placeholder="E-mail"
                  name="email"
                  value={email}
                  onChange={this.onChangeText}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Senha</label>
                <input
                  type="password"
                  className="bx--text-input"
                  required
                  placeholder="Senha"
                  name="password"
                  value={password}
                  onChange={this.onChangeText}
                />
              </div>
              <div className="bx--col-xs-12 bx--col-md-6 v-md-margin">
                <label className="bx--label">Repetir a Senha</label>
                <input
                  type="password"
                  className="bx--text-input"
                  required
                  placeholder="Repetir a Senha"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this.onChangePassword}
                />
              </div>
            </form>
          )}
          <div className="bx--row bx--col-md-12">
            <div className={showBack ? 'bx--col-md-6' : 'hide'}>
              <button
                type="submit"
                className="bx--btn btn-secondary-color v-md-margin btn-white"
                onClick={() => this.handleSubmit(-1)}
              >
                Voltar
              </button>
            </div>
            <div className={showBack ? 'bx--col-md-6' : 'bx--col-md-12'}>
              <button
                type="submit"
                form={targetForm}
                className="bx--btn btn-login-step btn-secondary-color v-md-margin"
                disabled={nextIsDisabled}
              // onClick={() => this.handleSubmit(1)}
              >
                {btnName}
              </button>
            </div>
          </div>
          <div className="bx--col-md-12">
            <NavLink to="/login" className="underline">
              Voltar para o login
            </NavLink>
          </div>
        </Card>
        <Modal
          className="bx--modal-secondary-hide hide--close-button"
          open={successModel}
          onRequestSubmit={this.closeModal}
          modalHeading={`${nome}, Obrigado!`}
          primaryButtonText="Ok, entendi"
          secondaryButtonText={null}
        >
          <div className="warning-modal-txt">
            <h3>Seu pré-cadastro foi feito com sucesso.</h3>
            <p className="font-size-13 v-md-margin">
              Em breve a equipe responsável confirmará seu acesso ao sistema DMJob.
            </p>
          </div>
        </Modal>
        {isSaving && <Loading small />}
      </div>
    );
  }
}

export default Register;



// WEBPACK FOOTER //
// ./src/screens/admin/Users/Register.js